module.exports = __webpack_public_path__ + "media/img/pages/profile/hug fr 2-4df0d949c693f290c9891de211bec8a8.jpg";